import { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FlightList from '../FlightList';
import FlightPagination from '../FlightPagination';
import SelectedFlight from '../SelectedFlight';
import FlightSearchBar from '../FlightSearchBar';
import PollingSearchProgressBar from '../../../PollingSearchProgressBar';
import { SearchModes } from '../../../../constants';
import LoadMoreFlightsButton from '../FlightPagination/LoadMoreFlightsButton';
import FlightFilterBar from '../FlightFilterBar/index';

const ModalContent = ({
  tripId,
  onModalClose,
  onCloseModal,
  doCheckoutOnSelect,
  isModalOpen,
  SortingFilterElement,
}) => {
  const { travelAgency } = useSelector((store) => store.user);
  const doHidePostSearchFilters =
    travelAgency && travelAgency.settings && travelAgency.settings.doHidePostSearchFilters;

  return (
    <>
      <div className="px-8 grid grid-flow-col auto-cols-max gap-5 font-bold border-b-2">
        <a
          role="button"
          tabIndex="-1"
          className="text-theme border-b-2 border-theme py-4 w-24 text-center"
        >
          Flight
        </a>
      </div>
      <PollingSearchProgressBar searchMode={SearchModes.FLIGHT} tripId={tripId} />
      <div className="m-5 mt-0">
        <LoadMoreFlightsButton tripId={tripId} className="mt-2" />
        <FlightSearchBar tripId={tripId} />
        <div className="flex justify-between">
          {!doHidePostSearchFilters && (
            <div className="w-full">
              <div className="font-bold ml-4 flex justify-between items-center">Filter by</div>
              <FlightFilterBar tripId={tripId} />
            </div>
          )}
          <div className="flex items-end pb-2 border-b-2">{SortingFilterElement}</div>
        </div>
        {!doCheckoutOnSelect && (
          <div className="w-full">
            <SelectedFlight tripId={tripId} onModalClose={onModalClose} isModalOpen={isModalOpen} />
          </div>
        )}
      </div>
      <div className="m-5">
        <FlightPagination tripId={tripId} />
      </div>
      <div className="my-5 mx-5">
        <FlightList
          onViewMoreClick={onCloseModal}
          isInsideModal
          tripId={tripId}
          onModalClose={onCloseModal}
          doCheckoutOnSelect={doCheckoutOnSelect}
        />
      </div>
      <div className="m-5">
        <FlightPagination tripId={tripId} />
      </div>
    </>
  );
};

ModalContent.propTypes = {
  tripId: PropTypes.string.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  doCheckoutOnSelect: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  SortingFilterElement: PropTypes.element.isRequired,
};

export default memo(ModalContent);
